import { Controller } from "@hotwired/stimulus"

// Custom confirmation modal for delete actions
// Usage:
//   - Add data-controller="confirm-delete" to wrapper element
//   - Add data-confirm-delete-target="modal" to modal element
//   - Add data-confirm-delete-target="itemName" to element showing item name in modal
//   - Add data-action="confirm-delete#requestConfirm" data-item-name="Name" to delete buttons
//   - Add data-action="confirm-delete#confirm" to confirm button in modal
export default class extends Controller {
  static targets = ["modal", "itemName"]

  connect() {
    this.modal = new bootstrap.Modal(this.modalTarget)
    this.pendingForm = null
  }

  requestConfirm(event) {
    event.preventDefault()
    
    const button = event.currentTarget
    const itemName = button.dataset.itemName || button.dataset.recordName || 'this item'
    
    this.itemNameTarget.textContent = itemName
    this.pendingForm = button.closest('form')
    this.modal.show()
  }

  confirm(event) {
    event.preventDefault()
    
    if (this.pendingForm) {
      // Remove any onsubmit blockers
      this.pendingForm.onsubmit = null
      this.pendingForm.submit()
    }
    this.modal.hide()
  }

  cancel(event) {
    event?.preventDefault()
    this.pendingForm = null
    this.modal.hide()
  }
}
